import { render, staticRenderFns } from "./ThuxListHeader.vue?vue&type=template&id=48c67588&"
import script from "./ThuxListHeader.vue?vue&type=script&lang=js&"
export * from "./ThuxListHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports